import { useQueryTemplates, useQueryTemplateThumbnails } from 'modules/quickActionsMenu/hooks';
import { useRumError } from 'services/observability/datadog';
import { Product, Team } from 'teams';

export const useTemplateSearch = (searchTerm: string) => {
  const addErrorSignal = useRumError();

  /** Templates */
  const { data, isLoading: isLoadingTemplates } = useQueryTemplates(searchTerm, {
    onError: (error) => {
      addErrorSignal(error, 'QuickActionsMenu > useQueryTemplates', {
        name: 'Quick Actions Menu templates GraphQL query',
        productName: Product.TEMPLATE_INDEX,
        teamName: Team.CAMPAIGN_TEAM,
      });
    },
  });
  const { info, results: templates = [] } = data?.templates || {};
  const templateIds = templates.map((template) => template.id);

  /** Thumbnails */
  const { data: thumbnails, isLoading: isLoadingThumbnails } = useQueryTemplateThumbnails(
    templateIds,
    {
      onError: (error) => {
        addErrorSignal(error, 'QuickActionsMenu > useQueryTemplateThumbnails', {
          name: 'Quick Actions Menu templates template thumbnail REST query',
          productName: Product.TEMPLATE_INDEX,
          teamName: Team.CAMPAIGN_TEAM,
        });
      },
    },
  );

  return { info, templates, thumbnails, isLoading: isLoadingTemplates || isLoadingThumbnails };
};
